import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type PermissionCatalogFetchFailedAction = {
	type: 'PERMISSION_CATALOG_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): PermissionCatalogFetchFailedAction => ({
	type: 'PERMISSION_CATALOG_FETCH_FAILED',
	payload,
});
